<template>
	<div class="machine-record">
		<div class="el-search vue-top-padding radius">
			<div class="el-right">
				<el-form
					ref="machineRecord"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="equipmentNo" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.equipmentNo"
							:placeholder="$t('machineRecord.pMachineNo')"
						></el-input>
					</el-form-item>
					<el-form-item style="margin: 0;">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('machineRecord')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="machineRecordList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="equipmentNo"
					:show-overflow-tooltip="true"
					:label="$t('machineRecord.equipmentNo')"
					:align="'center'"
					width="150px"
				></el-table-column>
				<el-table-column
					prop="userName"
					:show-overflow-tooltip="true"
					:label="$t('machineRecord.beforeLoginName')"
					:align="'center'"
					width="260px"
				></el-table-column>
				<el-table-column
					prop="nickName"
					:label="$t('machineRecord.beforeName')"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('machineRecord.createTime')"
					:align="'center'"
					width="170px"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="machineRecordList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "MachineRecord",
	data() {
		return {
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				equipmentNo: "",
			},
			machineRecordList: [],
			loading: false,
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.MachineRecord.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.machineRecordList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		onSubmit() {
			this.currentChange();
		},

		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.currentChange();
		},
	},
};
</script>

<style scoped></style>
